// Premium entitlement — cached for instant UI, refreshed from the billing adapter.

import { useEffect, useState, useCallback } from "react";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { getBilling } from "@/lib/billing";

const CACHE_KEY = "un_premium_cache_v1";

export const getCachedPremium = () => {
  try {
    return localStorage.getItem(CACHE_KEY) === "1";
  } catch {
    return false;
  }
};

const setCachedPremium = (v) => {
  try {
    localStorage.setItem(CACHE_KEY, v ? "1" : "0");
  } catch (e) {
    console.warn("[premium] cache:", e?.message || e);
  }
};

export const refreshPremium = async () => {
  const premium = await getBilling().isPremium();
  setCachedPremium(premium);
  return premium;
};

export const usePremium = () => {
  const [premium, setPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const v = await refreshPremium();
      setPremium(v);
    } catch (e) {
      console.warn("[premium] refresh:", e?.message || e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refresh);
    const nativeListener = Capacitor.isNativePlatform()
      ? App.addListener("appStateChange", ({ isActive }) => { if (isActive) refresh(); })
      : null;
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refresh);
      if (nativeListener) nativeListener.then(handle => handle.remove()).catch(() => undefined);
    };
  }, [refresh]);

  return { premium, loading, refresh };
};
